import { http, httpGet, httpPut, httpPost } from 'shared/services/httpService';
import appSettings from 'shared/settings/appSettings';
import { Location, LocationDetail } from 'shared/models/api/models';

const basePath = '/api/location/';

const fullyQualifiedAndEncodedURL = (relativeUri: string) => {
    return new URL(basePath + encodeURI(relativeUri), appSettings.api.portalApi).toString();
};


export const getLocations = async (): Promise<Location[]> => {
    return await httpGet<Location[]>(`${ fullyQualifiedAndEncodedURL(``).toString() }`);
}

export const getLocationsWithDetail = async (): Promise<LocationDetail[]> => {
    return await httpGet<LocationDetail[]>(`${ fullyQualifiedAndEncodedURL(`details`).toString() }`);
}

export const getLocationWithDetail = async (locationId: number): Promise<LocationDetail> => {
    return await httpGet<LocationDetail>(`${ fullyQualifiedAndEncodedURL(`details/${ locationId }`).toString() }`);
}

export const updateLocationMobile = async (LocationDetail: LocationDetail): Promise<boolean> => {
    return await httpPut<boolean>(`${ fullyQualifiedAndEncodedURL(`updatemobile/${ LocationDetail.id }/${ LocationDetail.siteMobileNumber }`).toString() }`);
}